<template>
  <v-container class="fill-height">
    <v-row
      align="center"
      justify="center"
      v-if="!submitted && requester && requester.corporateValidated === null"
    >
      <v-col cols="12" sm="8">
        <div>{{requester.firstname}} {{requester.lastname}} a indiqué avoir besoin de son véhicule pour des raisons professionnelles.</div>
        <div
          class="mt-5"
        >Si cette information est correcte, veuillez, s'il vous plait accepter sa demande.</div>
        <div class="mt-5">
          <v-btn outlined @click="submit(true)" :disabled="submitting">Accepter</v-btn>
          <v-btn outlined class="ml-4" @click="submit(false)" :disabled="submitting">Refuser</v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center"
      v-if="requester && requester.corporateValidated !== null && !submitted"
    >Ce lien de validation a expiré.</v-row>
    <v-row
      align="center"
      justify="center"
      v-if="submitted && requester.corporateValidated !== null"
    >Merci pour votre réponse!</v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  async mounted() {
    const { data: requester } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/corporate/${this.$route.params.corporateNano}`
    });
    this.requester = requester;
  },
  data: () => ({
    requester: undefined,
    submitted: false,
    submitting: false
  }),
  methods: {
    async submit(choice) {
      this.submitting = true;
      const { data } = await axios({
        method: "post",
        url: `${process.env.VUE_APP_API_URI}/corporate/${this.$route.params.corporateNano}`,
        data: {
          choice
        }
      });
      this.requester.corporateValidated = data.corporateValidated;
      this.submitted = true;
      this.submitting = false;
    }
  }
};
</script>
